module.exports = __webpack_public_path__ + "img/iphone-banner.5431d949.jpg";